// src/components/User/ProjectCards.js
import React, { useContext } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { AppContext } from './AppContext';
import { MapPin, Building2, Ruler, Bed } from 'lucide-react';

export default function ProjectCards({ projectType, projectTag, developerSlug }) {
    const { projectHighlights, developersData } = useContext(AppContext);

    const allHighlights = projectHighlights?.projectHighlights || [];
    const items = allHighlights
        .filter(item => item.project_type === projectType)
        .filter(item => developerSlug ? item.developer === developerSlug : true)
        .filter(item =>
            projectTag
                ? Array.isArray(item.project_tag) && item.project_tag.includes(projectTag)
                : true
        )
        .sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0));

    if (!items.length) {
        return (
            <p className="text-center text-gray-500">
                No {projectTag} projects to display.
            </p>
        );
    }

    const settings = {
        infinite: true,
        speed: 500,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        variableWidth: true,     // allows partial peeks
        centerMode: false,
    };

    return (
        <Slider {...settings}>
            {items.map(item => {
                const {
                    slug, name, image, price,
                    location, city,
                    area_min, area_max, area_unit,
                    configuration, property_type,
                    developer: devSlug, project_details_complete
                } = item;

                const devName =
                    developersData?.developers.find(d => d.slug === devSlug)?.name ||
                    devSlug ||
                    '—';

                const formattedPrice =
                    !isNaN(price) && Number(price) > 100
                        ? `${(Number(price) / 100).toFixed(2)} Cr`
                        : `${price} L`;

                const waUrl = `https://wa.me/919831577138?text=Hi, I would like to know more about ${encodeURIComponent(
                    name
                )}`;

                // conditionally choose href
                const href = project_details_complete
                    ? `/project/${slug}`
                    : waUrl;

                return (
                    <div key={slug} className="px-2" style={{ width: 320 }}>
                        <a href={href} target="_blank" rel="noopener noreferrer">
                            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition">
                                <img
                                    src={image || '/fallback.jpg'}
                                    alt={name}
                                    className="w-full h-40 object-cover rounded-t-lg"
                                />
                                <div className="p-4">
                                    <h3 className="text-indigo-700 font-bold uppercase truncate">{name}</h3>
                                    <div className="inline-flex items-baseline space-x-1">
                                        <span className="text-sm text-gray-500">Starting</span>
                                        <span className="text-base font-medium">₹{formattedPrice}</span>
                                    </div>

                                    <ul className="mt-2 space-y-1 text-sm text-gray-600">
                                        <li className="flex items-center">
                                            <MapPin className="h-4 w-4 text-amber-500 mr-1" />
                                            {location}, {city}
                                        </li>
                                        <li className="flex items-center">
                                            <Building2 className="h-4 w-4 text-amber-500 mr-1" />
                                            {devName}
                                        </li>
                                        <li className="flex items-center">
                                            <Ruler className="h-4 w-4 text-amber-500 mr-1" />
                                            {area_min}-{area_max} sqft ({area_unit})
                                        </li>
                                        <li className="flex items-center">
                                            <Bed className="h-4 w-4 text-amber-500 mr-1" />
                                            {configuration} {property_type}
                                        </li>
                                    </ul>
                                    <div className="flex justify-end mt-4">
                                        <div className="flex justify-end mt-4">
                                            <button
                                                className="
    border-2 border-solid border-transparent
    bg-indigo-600 text-white 
    px-3 py-1 rounded-lg 
    transition-colors duration-200 ease-in-out
    hover:bg-white hover:text-indigo-800 hover:border-indigo-800
  "
                                            >
                                                Know More
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </a>
                    </div>
                );
            })}
        </Slider>
    );
}
